import React, { useEffect, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import Context from 'stores/context';
import {
  ListEmptyBell,
} from 'components';

import ItemWorkout from '../Component/ItemWorkout';

const ListWorkoutSuggestionStyle = styled.div`
  color: ${props => props.theme.colors.white};
  margin-top: 20px;
  overflow: scroll;
  overflow-x: hidden;
  height: 517px;
`;


const ListWorkoutSuggestion = (props) => {
  const {
    history,
  } = props;

  const [reqListExercise, setReqListExercise] = useState(false);
  const [loading, setLoading] = useState(false);
  const context = useContext(Context);
  const {
    teacherTrainingStore,
    appStore,
    modalStore,
    i18n,
    technicalTrainingStore,
    filterWorkoutStore,
  } = context;

  const reloadListExercise = () => {
    setReqListExercise(true);
  };

  useEffect(() => {
    const callLoading = () => {
      appStore.toggleloading(false);
      setLoading(false);
    };

    const getListExercise = async () => {
      appStore.toggleloading(true);

      try {
        await technicalTrainingStore.doRequestListExerciseSuggestion({
          id: teacherTrainingStore.programId,
        });

        setReqListExercise(false);
        modalStore.closeModalError();
        window.scroll(0, 0);
        const el = document.querySelector('.wrapper-scroll');
        el.scroll(0, 0);
        appStore.toggleloading(false);
      } catch (error) {
        const msgTitle = i18n.t('error_loading');
        window.scroll(0, 0);
        modalStore.setTitle(msgTitle);
        modalStore.setModalNetworkCallback(reloadListExercise);
        modalStore.showModalError(error);
        appStore.toggleloading(false);
      }
    };

    if (reqListExercise) {
      setReqListExercise(false);
      getListExercise();
    }

    if (loading) {
      callLoading();
    }
  }, [
    loading,
    teacherTrainingStore,
    appStore,
    modalStore,
    i18n,
    technicalTrainingStore,
    reqListExercise,
  ]);

  if (technicalTrainingStore.reloadListExercise) {
    technicalTrainingStore.setReloadListExercise(false);
    reloadListExercise();
  }

  const loadingListWorkout = () => {
    appStore.toggleloading(true);
    technicalTrainingStore.plusWorkout();
    setLoading(true);
  };

  const onScroll = (e) => {
    const calc = e.target.scrollHeight - e.target.scrollTop;
    const heightClient = e.target.clientHeight + 1;
    const finish = technicalTrainingStore.finishListSuggestionTechnical;
    const result = (calc <= heightClient && finish === false);

    if (result && loading === false) {
      loadingListWorkout();
    }
  };

  const renderListEmpty = () => {
    const hasListExercise = (technicalTrainingStore.listSuggestionView.length > 0);
    const hasFilterSelected = (filterWorkoutStore.lengthSelected > 0);

    if (hasListExercise === false && hasFilterSelected) {
      return (
        <ListEmptyBell
          title={i18n.t('filter_empty')}
        />
      );
    }

    if (hasListExercise === false && hasFilterSelected === false) {
      return (
        <ListEmptyBell
          title={i18n.t('not_found_list')}
        />
      );
    }

    return false;
  };

  const renderList = () => {
    const listItems = technicalTrainingStore.listSuggestionView.map(exercise => (
      <ItemWorkout
        key={exercise.id}
        exercise={exercise}
        tabSelected="suggestion"
        history={history}
      />
    ));

    return listItems;
  };

  return (
    <ListWorkoutSuggestionStyle onScroll={onScroll} className="wrapper-scroll">
      {renderListEmpty()}
      {renderList()}
    </ListWorkoutSuggestionStyle>
  );
};

ListWorkoutSuggestion.defaultProps = {
  history: {},
};

ListWorkoutSuggestion.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

export default observer(ListWorkoutSuggestion);
